// extracted by mini-css-extract-plugin
module.exports = {"root":"TalentList_root__3uR3m","following":"TalentList_following__3jwbq","itemWrapper":"TalentList_itemWrapper__3Erfp","paginationWrapper":"TalentList_paginationWrapper__1YLr0"};